<template>
  <div class="per_statement">
    <router-link to="/">返回</router-link>
    <h2 class="blue_title">个人声明申请须知</h2>
    <p class="content-text-indent">根据《金融信用信息基础数据库个人声明业务规程》，个人需要添加个人声明的，可以向征信中心邮寄申请材料或前往各地征信分中心提交申请材料。</p>
    <span class="blue_span">一、个人声明申请流程：</span>
    <div>
      <p class="content-text-indent">填表→微信预约→出示预约信息→提交材料→审核确认是否受理；声明不受理的，予以退回并告知不予接收的原因。</p>
    </div>
    <span class="blue_span">二、个人需要添加个人声明提交材料顺序如下:（统一用A4纸规格）</span>
    <div>
      <p class="content-text-indent">1、填写《个人声明申请表》（见附件1）；</p>
      <p class="content-text-indent">2、本人有效身份证件原件及复印件；</p>
      <p class="content-text-indent">3、出示本人声明申请日当天的个人信用报告；</p>
      <p class="content-text-indent">4、如委托监护人添加个人声明（限制民事行为能力或无民事行为能力的个人）提交监护关系公证证明材料原件；</p>
      <p class="content-text-indent">5、监护人及被监护人有效身份证件原件及复印件。</p>
    </div>
    <span class="red_span">特别提示：</span>
    <div>
      <p class="content-text-indent">1、声明内容应在100字以内，可由征信分中心接收材料，由征信中心审核是否受理；</p>
      <p class="content-text-indent">2、有效身份证件包括：中国公民的居民身份证，军人的军官证、士兵证，港澳台人士的通行证，外籍人士的护照。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PerStatement.vue'
}
</script>

<style scoped>
.per_statement {
  padding: 20px;
}

.blue_title {
  text-align: center;
  font-size: 20px;
  font-weight: normal;
  color: #3b88d6;
}

.blue_span {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  color: #3b88d6;
}

.red_span {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  color: #f00;
}

.content-text-indent {
  text-indent: 2em;
  font-size: 12px;
  margin: 0;
  color: #999;
  line-height: 24px;
}
</style>
